<main>
	<div class="btn-row">
		<app-vinavon-button>
			<button [matMenuTriggerFor]="menu" class="medium" mat-fab matTooltip="{{ 'MAIN_APP_ADRESSES.erfassen' | translate }}" style="background-color: #ffffff">
				<mat-icon class="low">add</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button (click)="onNewAddress()" [disabled]="!userAuthService.getRight(BenutzerModels.UserRightCodes.AdresseErstellen)" mat-menu-item>Adresse</button>
				<button (click)="onNewPartner()" mat-menu-item>
					{{ "MAIN_APP_ADRESSES.ansprechpartner" | translate }}
				</button>
			</mat-menu>
			
			<button (click)="delAddress()" [disabled]="!userAuthService.getRight(BenutzerModels.UserRightCodes.AdresseLoeschen) || !(currentAddressID$ | async)" class="medium" mat-fab
			        matTooltip="{{ 'MAIN_APP_ADRESSES.adresseLöschen' | translate }}" style="background-color: #ffffff">
				<mat-icon class="low">delete</mat-icon>
			</button>
			
			<button (click)="showNote()" [disabled]="!(currentAddressID$ | async)" class="medium" mat-fab matTooltip="{{ 'MAIN_APP_DASHBOARD.notizen' | translate }}" style="background-color: #ffffff">
				<mat-icon class="low">content_paste</mat-icon>
			</button>
		
		</app-vinavon-button>
	</div>
	<div class="content">
		<app-collapsible-box [title]="'MAIN_APP_ADRESSES.ADRESSENSUCHEN'">
			<app-address-search #addressSearchComponent (addressSelected)="addressSelected($event)">
			
			</app-address-search>
		</app-collapsible-box>
		<app-address-detail #addressDetailComponent (selectedObject)="objectSelected($event)" [currentAddressID$]="currentAddressID$">
		
		</app-address-detail>
	</div>
</main>
